import { render, staticRenderFns } from "./userRecord.vue?vue&type=template&id=6f84f0fd&scoped=true&"
import script from "./userRecord.vue?vue&type=script&lang=js&"
export * from "./userRecord.vue?vue&type=script&lang=js&"
import style0 from "./userRecord.vue?vue&type=style&index=0&id=6f84f0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84f0fd",
  null
  
)

export default component.exports